import React, { FC } from 'react';
import { useT } from 'hooks';
import * as S from './styled';
import logo from './img/logo.png';

export const Header: FC = props => {
	const { T } = useT();

	return (
		<S.Container>
			<S.LogoWrapper>
				<S.Img src={logo} alt='logo verv' />
				<S.Title>{T('new_loader_title')}</S.Title>
			</S.LogoWrapper>
			<S.SubTitle>
				Your{' '}
				<span>
					personalized
					<br />
				</span>{' '}
				3-month plan
			</S.SubTitle>
		</S.Container>
	);
};
